export default "__VITE_ASSET__DB1n56QP__"